import React from "react";
import OrganizarPedido from "../components/OrganizarPedido.jsx";

const InformeOrganizarPedido = () => {
  return (
    <>
      <OrganizarPedido />
    </>
  );
};

export default InformeOrganizarPedido;